import { FilterType, Filter, FilterKey, RecordedInterviewSystemStatus } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '../../types';
import { IOption } from 'shared-components';
import { getRecordedInterviewInfoStatusString } from '@/utilities/formatting';
import { UserRole } from '@/store/auth/types';

const getOptions = (userRole?: UserRole): IOption[] => {
  const isAgentUser = (userRole && [UserRole.Agent, UserRole.AgencyAdmin].includes(userRole)) ?? false;
  return [
    {
      label: getRecordedInterviewInfoStatusString(RecordedInterviewSystemStatus.INVITED),
      value: RecordedInterviewSystemStatus.INVITED,
    },
    {
      label: getRecordedInterviewInfoStatusString(RecordedInterviewSystemStatus.RECORDED),
      value: RecordedInterviewSystemStatus.RECORDED,
    },
    ...(isAgentUser
      ? []
      : [
          {
            label: getRecordedInterviewInfoStatusString(RecordedInterviewSystemStatus.FAILED),
            value: RecordedInterviewSystemStatus.FAILED,
          },
        ]),
    ...(isAgentUser
      ? []
      : [
          {
            label: getRecordedInterviewInfoStatusString(RecordedInterviewSystemStatus.PASSED),
            value: RecordedInterviewSystemStatus.PASSED,
          },
        ]),
    ...(isAgentUser
      ? []
      : [
          {
            label: getRecordedInterviewInfoStatusString(RecordedInterviewSystemStatus.RESIT),
            value: RecordedInterviewSystemStatus.RESIT,
          },
        ]),
    {
      label: getRecordedInterviewInfoStatusString(RecordedInterviewSystemStatus.ATTEMPTED),
      value: RecordedInterviewSystemStatus.ATTEMPTED,
    },
    {
      label: getRecordedInterviewInfoStatusString(RecordedInterviewSystemStatus.NONE),
      value: RecordedInterviewSystemStatus.NONE,
    },
  ];
};

const key = FilterKey.RECORDED_INTERVIEW;
export const getRecordedInterviewFilter = ({ activeFilters, userRole }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  const options = getOptions(userRole).map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });
  return {
    name: 'Recorded interviews',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: false,
    options: {
      SELECT_MANY: options,
    },
  };
};
